import React, { Component } from "react"
import { isMobile, isAndroid, isIOS } from "react-device-detect"
import Svg from "../_svgs/svg"

export default class Footer extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    window.addEventListener("resize", (event) => {
      this.setState({ screenWidth: event.target.screen.width })
    })
  }

  render() {
    return (
      <div className="footer-with-mobile-accordion">
        <div className="footer-navigation">
          <div className="w--wider">
            <div className="grid no-gutter">
              <div className="grid-item col--12 col-sm--5 col-md--7">
                <ColumnLinks columnLinks={this.props.column1Links} />
                <ColumnLinks columnLinks={this.props.column2Links} />
                <ColumnLinks columnLinks={this.props.column3Links} />
              </div>
              <div className="grid-item col--12 col-sm--7 col-md--5">
                <div className="contentright">
                  <div className="download-app-container">
                    <div className="mobileappimg">
                      <img src={this.props.appImage || "/Static/mobileapp.png"} />
                    </div>
                    <div className="apps">
                      <div className="title">{this.props.downloadAppText || "Download CPH App"}</div>
                      {isMobile ? (
                        isIOS ? (
                          <a href={this.props.appStoreLink}>
                            <img src={this.props.appStoreImage || "/Static/appstore.svg"} />
                          </a>
                        ) : isAndroid ? (
                          <a href={this.props.playStoreLink}>
                            <img src={this.props.playStoreImage || "/Static/playstore.svg"} />
                          </a>
                        ) : (
                          ""
                        )
                      ) : (
                        <React.Fragment>
                          <a href={this.props.appStoreLink}>
                            <img src={this.props.appStoreImage || "/Static/appstore.svg"} />
                          </a>
                          <a href={this.props.playStoreLink}>
                            <img src={this.props.playStoreImage || "/Static/playstore.svg"} />
                          </a>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                  <div className="footer-navigation__social">
                    {this.props.socialLinks && this.props.socialLinks.length > 0 ? (
                      <ul className={"social-list"}>
                        {this.props.socialLinks.map((link, index) => {
                          const svg = link.socialIcon.split("@")[0]
                          return (
                            <li key={index} className={"social-list__item"}>
                              <a className="button button--social has-icon" href={link.linkUrl} target={link.linkTarget}>
                                {link.socialIconUpload && link.socialIconUpload ? (
                                  <img className={"icon"} src={link.socialIconUpload} />
                                ) : (
                                  <Svg iconName={svg} fillColor={"#FFF"} />
                                )}
                              </a>
                            </li>
                          )
                        })}
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-footer__bottom">
          <div className="w--wider">
            <div className="leftside">
              <div
                className="copyrighttext"
                dangerouslySetInnerHTML={{ __html: window.innerWidth < 769 ? this.props.copyrightTextMobile : this.props.copyrightText }}
              ></div>
              {this.props.legalLinks && this.props.legalLinks.length > 0 ? (
                <div>
                  {this.props.legalLinks.map((link, index) => {
                    if (index !== this.props.legalLinks.length - 1) {
                      return (
                        <a key={index} className="button button--link" target={link.target} href={link.href}>
                          <span className="text">{link.text}&ensp;·</span>
                        </a>
                      )
                    }
                    return (
                      <a key={index} className="button button--link" target={link.target} href={link.href}>
                        <span className="text">{link.text}</span>
                      </a>
                    )
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="footerlogo">
              <a className="button button--logo" href="" style={{ width: "auto" }}>
                <Svg iconName={this.props.logo} iconClass={"icon"} />
                <Svg iconName={this.props.logomobile} iconClass={"icon2"} />
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

class ColumnLinks extends Component {
  showHideContent(event, classname) {
    let elem = event.currentTarget
    elem.__toggle = !elem.__toggle
    let target = elem.parentElement.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      elem.classList.add("is-active")
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
    }
  }

  render() {
    if (this.props.columnLinks) {
      const { columnLinks, headerLink, headerLinkText, headerLinkTarget } = this.props.columnLinks
      return (
        <div className="footer-navigation__links">
          <a href={headerLink} target={headerLinkTarget}>
            <h4>{headerLinkText}</h4>
          </a>
          <a className="topmenuitem button button--link has-icon" onClick={(e) => this.showHideContent(e, ".contentWrapper")}>
            <span className="text">{headerLinkText}</span>
          </a>
          {window.innerWidth < 768 ? (
            <div className={"contentWrapper show-hide"}>
              <LinkList columnLinks={columnLinks} />
            </div>
          ) : (
            <LinkList columnLinks={columnLinks} />
          )}
        </div>
      )
    }
    return
  }
}

class LinkList extends Component {
  render() {
    if (this.props.columnLinks && this.props.columnLinks.length > 0) {
      return (
        <ul className={"links-list"}>
          {this.props.columnLinks.map((link, index) => {
            return (
              <li key={index} className="links-list__item">
                <a className="button button--link has-icon" target={link.target} href={link.href}>
                  <span className="text">{link.text}</span>
                </a>
              </li>
            )
          })}
        </ul>
      )
    }
    return
  }
}
